export default "__VITE_ASSET__BaNpcnHM__"